import {inheritPrototype, isDef} from '../util/util'
import echarts from 'echarts'
import Base from './base'
// 仪表盘
var GaugeShare = function (dataList, type) {
  Base.call(this)
  this.type = type
  if (dataList) {
    this.xList = isDef(dataList.xList) ? dataList.xList : []
    this.yList = isDef(dataList.yList) ? dataList.yList : []
    this.optionSet = isDef(dataList.optionSet) ? dataList.optionSet : {}
  } else {
    this.xList = []
    this.yList = []
    this.optionSet = {}
  }
  this.init()
}
inheritPrototype(GaugeShare, Base)
GaugeShare.prototype.init = function () {
  this.option.title = this.getTitle()
  this.option.grid = this.getGrid()
  this.option.tooltip = this.getTooltip()
  this.option.series = this.getSeries()
  let legend = []
  this.option.legend = this.getLegend(legend)
}
GaugeShare.prototype.getSeries = function () {
  let series = []
  let unit1 = isDef(this.optionSet.unit1) ? this.optionSet.unit1 : '家'
  if (this.yList && this.yList.length > 0) {
    for (let i = 0; i < this.yList.length; i++) {
      let color = isDef(this.yList[i].color) ? this.yList[i].color : []
      let areaStyle = isDef(this.yList[i].areaStyle) ? this.yList[i].areaStyle : []
      let name = isDef(this.yList[i].name) ? this.yList[i].name : ''
      let valueNum = isDef(this.yList[i].valueNum) ? this.yList[i].valueNum : []
      let data = isDef(this.yList[i].data) ? this.yList[i].data : []

      let areaType = areaStyle.length > 0 ? areaStyle[0] : 'normal'
      let center = areaStyle.length > 2 && areaStyle[1].length > 0 ? areaStyle[1] : ['32%', '55%']
      let gaugeSeries = {}

      if (areaType == 'small') {
        let smallGauge = {
          name: name,
          type: 'gauge',
          radius: '55%',
          center: center,
          detail: {
            formatter: [
              '{a|' + name + '}\n',
              '{b|' + valueNum + '}',
              '{b1|' + unit1 + '}'
            ].join(''),
            rich: {
              a: {
                color: '#5B5F65',
                fontSize: 14
              },
              b: {
                color: '#459AFF',
                fontSize: 18,
                fontWeight: 600
              },
              b1: {
                color: '#459AFF',
                fontSize: 14
              },
              c: {
                color: '#5B5F65',
                fontSize: 18
              }
            }
          },
          endAngle: 45,
          pointer: {width: 2},
          axisTick: {show: false},
          axisLabel: {show: true},
          axisLine: {
            lineStyle: {
              width: 8,
              color: [
                [1, new echarts.graphic.LinearGradient(
                  0, 0, 1, 0, [
                    {offset: 0, color: color.length === 2 ? color[0] : '#AE9DF8'},
                    {offset: 1, color: color.length === 2 ? color[1] : '#5FCBFF'}
                  ]
                )
                ]
              ]
            }
          },
          splitLine: {
            length: 8,
            lineStyle: {color: '#fff'}
          },
          data: data
        }
        gaugeSeries = smallGauge
      } else {
        let normalGauge = {
          name: name,
          type: 'gauge',
          radius: '75%',
          center: ['65%', '50%'],
          detail: {
            formatter: [
              '{a|' + name + '}\n',
              '{b|' + valueNum + '}',
              '{b1|' + unit1 + '}\n',
              '{c|{value}%}'
            ].join(''),
            rich: {
              a: {
                color: '#5B5F65',
                fontSize: 14
              },
              b: {
                color: '#459AFF',
                fontSize: 24,
                fontWeight: 600
              },
              b1: {
                color: '#459AFF',
                fontSize: 18
              },
              c: {
                color: '#5B5F65',
                fontSize: 18
              }
            }
          },
          pointer: {width: 5},
          axisTick: {show: false},
          axisLabel: {show: true},
          axisLine: {
            lineStyle: {
              width: 18,
              color: [
                [1, new echarts.graphic.LinearGradient(
                  0, 0, 1, 0, [
                    {offset: 0, color: color.length === 2 ? color[0] : '#5892F8'},
                    {offset: 1, color: color.length === 2 ? color[1] : '#2FE0B2'}
                  ]
                )
                ]
              ]
            }
          },
          splitLine: {
            length: 18,
            lineStyle: {color: 'auto'}
          },
          data: data
        }
        gaugeSeries = normalGauge
      }
      series.push(gaugeSeries)
    }
  }
  return series
}


export default GaugeShare
